import axios from 'axios';

export const api = axios.create({
  headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
});

export function updateCompany(data, files, cbSuccess, cbError) {
  const body = new FormData();
  appendFormdata(body, data, 'company');

  if (files.length > 0) {
    body.append('company[headshot]', files[0], files[0].name);
  }

  return (
    api.put(`/companies/${data.slug}`, body, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(() => cbSuccess())
    .catch(error => cbError(error))
  );
}

export function searchGuests(slug, search) {
  return api.get('/events/search_guests', { params: { slug, search } });
}

export function fetchInviteMembers(slug, page, search = null) {
  return api.get(`/events/${slug}/invite_guests`, {
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    data: {},
    params: { page, search }
  });
}

export function sendEventInvites(slug, userIds, currentUserList) {
  return api.post(
    `/events/${slug}/send_invites`, {
      event: { user_ids: userIds, current_user_list: currentUserList}
    }
  );
}

export function sendImportedInvites(data, file, cbSuccess, cbError) {
  const body = new FormData();
  appendFormdata(body, data, 'event');

  if (file) {
    body.append('event[imported_csv]', file, file.name);
  }

  return (
    api.post(
      `/events/${data.slug}/send_imported_invites`, body, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => cbSuccess(res))
    .catch(error => cbError(error))
  )
}

export async function fetchInviteesForCSV(slug) {
  return await api.get(`/events/${slug}/invited_guests`);
}

export function updateCommunityOnboarding(data, files, cbSuccess) {
  const body = new FormData();
  appendFormdata(body, data, 'community');

  if (files.length > 0) {
    body.append('community[header_image]', files[0], files[0].name);
  }

  return (
    api.put(`/${data.slug}/onboarding`, body, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(community => cbSuccess(community.data))
  );
}

export function unsyncStripeConnect(communitySlug, cbSuccess) {
  return api.post(`/${communitySlug}/onboarding/stripe_unsync`)
            .then(community => cbSuccess(community.data));
}

export function getStripeConnectAuth(communitySlug, cbSuccess, cbError) {
  return api.get(`/${communitySlug}/onboarding/stripe_connect_account_link`)
            .then(accountLink => cbSuccess(accountLink.data))
            .catch(error => cbError(error.response.data));
}

export function inviteCommunityMembers(data, cbSuccess, cbError) {
  return (
    api.post(`/${data.slug}/manage/invites`, data)
    .then(data => cbSuccess(data))
    .catch(error => cbError(error.response.data))
  );
}

export const appendFormdata = (FormData, data, name = '') => {
  if (typeof data === 'object' && !(data instanceof File)) {
    for (const key in data) {
      if (name === '') appendFormdata(FormData, data[key], key);
      else {
        const child_name = data instanceof Array ? `${name}[]` : `${name}[${key}]`;
        appendFormdata(FormData, data[key], child_name);
      }
    }
  } else if (typeof data !== 'undefined') FormData.append(name, data);
};

export const mockAPICall = (delay) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve('API call completed successfully');
    }, delay);
  });
};
